import React from 'react';
import { FiArrowLeft, FiCalendar } from 'react-icons/fi';
import LmsMainDetail from '../components/LmsMainDetail';

const TabletLearningDetail = ({ lesson, onBack }) => (
  <section className="mobile-lms-detail tablet-lms-detail" aria-label={`${lesson.title} 상세`}>
    <header className="mobile-lms-detail__header tablet-lms-detail-mobile-header">
      <button type="button" onClick={onBack} aria-label="학습 목록으로 돌아가기">
        <FiArrowLeft aria-hidden="true" />
      </button>
      <div>
        <span>학습 상태</span>
        <strong>{lesson.title}</strong>
      </div>
      <span aria-hidden="true" />
    </header>

    <div className="mobile-lms-detail__meta">
      <FiCalendar aria-hidden="true" />
      <span>{lesson.date}</span>
      <i />
      <span>{lesson.writer}</span>
    </div>

    <div className="mobile-lms-detail__body tablet-lms-detail-mobile-body">
      <LmsMainDetail sno={lesson.sno} showHeader={false} />
    </div>
  </section>
);

export default TabletLearningDetail;
